import script from "./IncidentsView.vue?vue&type=script&setup=true&lang=ts"
export * from "./IncidentsView.vue?vue&type=script&setup=true&lang=ts"

import "./IncidentsView.vue?vue&type=style&index=0&id=a6c5290a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a6c5290a"]])

export default __exports__